import { render, staticRenderFns } from "./CalculadoraDialogAddProcedimentos.vue?vue&type=template&id=0b76b281"
import script from "./CalculadoraDialogAddProcedimentos.vue?vue&type=script&lang=ts"
export * from "./CalculadoraDialogAddProcedimentos.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports